/**
 * Mapa único rota → id de página (Gestão de Roles / systemPages).
 * Manter sincronizado com Settings.tsx systemPages.
 */
export const ROUTE_TO_PAGE_MAP = {
  '/dashboard': 'dashboard',
  '/clients': 'clients',
  '/solicitacoes-exclusao': 'solicitacoes-exclusao',
  '/catalogo': 'catalogo',
  '/rewards': 'rewards',
  '/suppliers': 'suppliers',
  '/boxes': 'boxes',
  '/embalagem': 'embalagem',
  '/organizar-caixa': 'organizar-caixa',
  '/invoices': 'invoices',
  '/labels': 'labels',
  '/coletas': 'coletas',
  '/coleta': 'coletas',
  '/rastreamento': 'rastreamento',
  '/tracking': 'tracking',
  '/costs': 'costs',
  '/payments': 'payments',
  '/pagamentos-retirada': 'pagamentos-retirada',
  '/pendencias-financeiras': 'pendencias-financeiras',
  '/currency': 'currency',
  '/central-fiscal': 'central-fiscal',
  '/users': 'users',
  '/settings': 'settings',
  '/profile': 'profile',
};

/** Ordem de redirecionamento pós-login / acesso negado */
export const PAGE_PRIORITY = [
  'dashboard',
  'clients',
  'solicitacoes-exclusao',
  'catalogo',
  'rewards',
  'suppliers',
  'boxes',
  'embalagem',
  'organizar-caixa',
  'invoices',
  'payments',
  'pagamentos-retirada',
  'pendencias-financeiras',
  'currency',
  'labels',
  'coletas',
  'tracking',
  'rastreamento',
  'costs',
  'central-fiscal',
  'users',
  'settings',
];

/** Ids antigos → novos (ACL / paginaList) */
const PAGE_ID_ALIASES = {
  documents: 'central-fiscal',
};

/**
 * Normaliza paginaList vinda da API (array, JSON string, snake_case, etc.).
 */
export function normalizePaginaList(raw) {
  if (Array.isArray(raw)) {
    return raw.map(String).map(resolvePageId).filter(Boolean);
  }

  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (!trimmed) return [];

    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return parsed.map(String).map(resolvePageId).filter(Boolean);
      }
    } catch {
      // lista separada por vírgula
      return trimmed
        .split(',')
        .map((s) => s.trim().replace(/^["']|["']$/g, ''))
        .map(resolvePageId)
        .filter(Boolean);
    }
  }

  return [];
}

function resolvePageId(id) {
  const key = String(id || '').trim();
  if (!key) return '';
  return PAGE_ID_ALIASES[key] || key;
}

export function normalizeRole(role) {
  if (!role || typeof role !== 'object') return null;

  const permissaosId =
    role.permissaos_id ?? role.permissao?.id ?? role.permissao_id ?? null;

  const paginaList = normalizePaginaList(
    role.paginaList ?? role.pagina_list ?? role.paginas ?? role.pages
  );

  return {
    ...role,
    permissaos_id: permissaosId != null ? Number(permissaosId) : null,
    paginaList,
  };
}
